import React, { useCallback, useEffect, useState } from "react";
import userResources from "api/userResources";
import { toast } from "react-toastify";
import CustomComponent from "./CustomComonent";

export default function DestinationSales() {
  const [fromData, setFromData] = useState([]);
  const [toData, setToData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fromSearchValue, setFromSearchValue] = useState("");
  const [toSearchValue, setToSearchValue] = useState("");

  // Generic function to fetch airport data based on the search value
  const fetchAirports = useCallback(async (searchValue, setData) => {
    if (!searchValue) return;
    setIsLoading(true);
    const params = { iata: searchValue };
    try {
      const response = await userResources.airportDataList(params);
      // Map the API response to the format expected by the Select component
      const airports = response.data.data.map((item) => ({
        value: item.id,
        label: item.iata + " " + item.name,
      }));
      setData(airports);
    } catch (error) {
      toast(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Trigger fetch when the "from" search value changes
  useEffect(() => {
    fetchAirports(fromSearchValue, setFromData);
  }, [fromSearchValue, fetchAirports]);

  // Trigger fetch when the "to" search value changes
  useEffect(() => {
    fetchAirports(toSearchValue, setToData);
  }, [toSearchValue, fetchAirports]);

  return (
    <div>
      <CustomComponent
        destinationSales={{
          destination: true,
          fromData,
          // Pass callbacks to update the search value
          setFromSearchValue,
          setToSearchValue,
          toData,
          isLoading,
        }}
      />
    </div>
  );
}
